import React from 'react'
import { WorkItem, getWorkItems, deleteWorkItem } from 'utils/WorkItemsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';


export default function WorkItemGrid() {
  const columns = WorkItem.columns.filter(col => col.title !== "WorkItemId" && col.title !== "WorkItemsStatusId" && col.title !== "WitypeId" && col.title !== "Delete" && col.title !== "Edit" )
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Work Items"
  const getFormPath = () => import('components/WorkItems/AddWorkItem')

  return (
    <div style={{ paddingTop: '20px' }}>
      {selectedProject ?
        <Grid 
          columns={columns}
          title={title}
          getRecords={getWorkItems}
          deleteRecord={deleteWorkItem}
          selectedProject={selectedProject}
          component="WorkItems"
          formPath={getFormPath}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 25]
          }}
          localization={{
            body: { editRow: { deleteText: "Are you sure you'd like to mark this row as inactive?" } }
          }}
        /> : <SkeletonGrid title={title} />
      }
    </div>
  )
}